import { useState } from "react";
import { Bell } from "lucide-react";
import { FadeUp } from "../site/Reveal";
import { LogoLoupe } from "./LogoLoupe";
import { WaitlistDialog } from "./WaitlistDialog";

export const ComingSoonCard = ({ item, className = "", delay = 0 }) => {
  const [open, setOpen] = useState(false);
  return (
    <FadeUp delay={delay} className={`group relative min-h-[380px] overflow-hidden bg-stone ${className}`} data-testid={`coming-soon-card-${item.id}`}>
      <img src={item.img} alt={item.title} loading="lazy" style={{ objectPosition: item.pos ?? "center" }} className="absolute inset-0 h-full w-full object-cover grayscale-[35%] transition-[transform,filter] duration-[1.2s] ease-out group-hover:scale-105 group-hover:grayscale-0" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/15 to-transparent" />
      <span className="absolute left-4 top-4 bg-ivory px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-ink" data-testid={`coming-soon-badge-${item.id}`}>Coming Soon</span>
      <LogoLoupe item={item} />
      <div className="absolute inset-x-0 bottom-0 p-5 text-white md:p-7">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#D8DCE0]">{item.tag}</p>
        <p className="mt-2 font-display text-3xl leading-tight">{item.title}</p>
        <p className="mt-2 max-w-xs text-sm text-[#E4E4E6]">{item.text}</p>
        <button onClick={() => setOpen(true)} data-testid={`coming-soon-notify-${item.id}`} className="mt-4 inline-flex items-center gap-2 border-b border-white/70 pb-1 text-[11px] font-medium uppercase tracking-[0.2em] transition-opacity hover:opacity-80">
          <Bell className="h-3.5 w-3.5" /> Join waitlist
        </button>
      </div>
      <WaitlistDialog item={item} open={open} onOpenChange={setOpen} />
    </FadeUp>
  );
};
